import React, { useState, useEffect } from 'react';
import { Select, Card, Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import DataChart from './DataChart';
import DataTable from './DataTable';
import { loadCSVData, exportData } from '../utils/dataUtils';

const { Option } = Select;

const HydroForecastPage = () => {
  const [sites] = useState(['高道', '坪石二', '石角','英德五', '韶关二']);
  const [timeScales] = useState(['天', '月']);
  
  // 定义不同时间尺度对应的模型
  const dayModels = ['LSTM', 'CNN', 'SVM', '集成SAM1','观测'];
  const monthModels = ['SVM', 'KNN', 'CART', '集成SAM1','观测'];

  const [selectedSite, setSelectedSite] = useState('坪石二');
  const [selectedTimeScale, setSelectedTimeScale] = useState('天');
  const [selectedModel, setSelectedModel] = useState('集成SAM1');
  
  // 根据时间尺度获取可用模型
  const getAvailableModels = (timeScale) => {
    return timeScale === '天' ? dayModels : monthModels;
  };
  
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getFileName = (site, timeScale, model) => {
    // 特殊处理韶关_天_LSTM文件名（文件名中LSTM后面有空格）
    if (site === '韶关' && timeScale === '天' && model === 'LSTM') {
      return `${site}_${timeScale}_${model} .csv`;
    }
    return `${site}_${timeScale}_${model}.csv`;
  };

  // 处理时间尺度变化
  const handleTimeScaleChange = (timeScale) => {
    setSelectedTimeScale(timeScale);
    const availableModels = getAvailableModels(timeScale);
    // 如果当前选择的模型在新的时间尺度下不可用，则重置为第一个可用模型
    if (!availableModels.includes(selectedModel)) {
      setSelectedModel(availableModels[0]);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const fileName = getFileName(selectedSite, selectedTimeScale, selectedModel);
        const csvData = await loadCSVData(fileName);
        setData(csvData);
      } catch (error) {
        console.error('数据加载错误:', error);
        if (error.message.includes('不存在或无法访问')) {
          message.error(`没有获取到该数据：${selectedSite} - ${selectedTimeScale} - ${selectedModel}`);
        } else {
          message.error(`加载数据失败: ${error.message}`);
        }
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadData();
  }, [selectedSite, selectedTimeScale, selectedModel]);

  const handleExport = () => {
    if (data.length === 0) {
      message.warning('没有数据可以导出');
      return;
    }
    
    const fileName = `${selectedSite}_${selectedTimeScale}_${selectedModel}_导出数据`;
    exportData(data, fileName);
    message.success('数据导出成功');
  };

  return (
    <div style={{ padding: '20px' }}>
      <div className="filters" style={{ marginBottom: '20px', display: 'flex', gap: '16px', alignItems: 'end' }}>
        <div className="filter-item">
          <label>站点:</label>
          <Select
            value={selectedSite}
            onChange={setSelectedSite}
            style={{ width: 120 }}
          >
            {sites.map(site => (
              <Option key={site} value={site}>{site}</Option>
            ))}
          </Select>
        </div>
        
        <div className="filter-item">
          <label>时间尺度:</label>
          <Select
            value={selectedTimeScale}
            onChange={handleTimeScaleChange}
            style={{ width: 120 }}
          >
            {timeScales.map(scale => (
              <Option key={scale} value={scale}>{scale}</Option>
            ))}
          </Select>
        </div>
        
        <div className="filter-item">
          <label>模型:</label>
          <Select
            value={selectedModel}
            onChange={setSelectedModel}
            style={{ width: 120 }}
          >
            {getAvailableModels(selectedTimeScale).map(model => (
              <Option key={model} value={model}>{model}</Option>
            ))}
          </Select>
        </div>
        
        <Button 
          type="primary" 
          icon={<DownloadOutlined />}
          onClick={handleExport}
          disabled={data.length === 0}
        >
          导出数据
        </Button>
      </div>

      <div style={{ display: 'grid', gap: '20px' }}>
        <Card title="数据可视化">
          <DataChart 
            data={data} 
            loading={loading}
            title={`${selectedSite} - ${selectedTimeScale} - ${selectedModel}`}
          />
        </Card>
        

      </div>
    </div>
  );
};

export default HydroForecastPage;